import React, { useState } from "react";
import "../styles/Services2.css";

// Import images
import image1 from "../assets/preis_bilder/NagayuHP.png";
import image2 from "../assets/preis_bilder/ThalassoHP.png";

const services2Data = [
    {
        id: 1,
        title: "Nagayu SPA",
        shortDescription: "Nagayu Spa - Feuchtigkeit, Balance & Regeneration",
        fullDescription: `
                    <p><strong>Nagayu Carbonated Spa Behandlung</strong>  ist eine innovative japanische Feuchtigkeits- und Hydrotherapie, die die Durchblutung der Haut fördert und nachhaltig die Haut- und Fellgesundheit Ihres Hundes verbessert.</p>
                    <p>Die feinperlige Kohlensäure dringt tief in die Haut ein, öffnet die Poren und unterstützt durch Milchsäurebakterien die natürlichen Regenerationsprozesse.</p>
                    <p>Diese Behandlung wird besonders bei Hunden mit Hautproblemen eingesetzt und zeigt beeindruckende Ergebnisse - sanft, natürlich und effektiv.</p>

                    <ul style='text-align: left;'>
                        <p><strong>Wirkungsweise</strong>
                        <li>Aktivieren die Hautdurchblutung</li>
                        <li>Fördern den Sauerstofftransport in den Zellen</li>
                        <li>Unterstützen die natürliche Hauterneuerung</li>
                    </ul>

                    <p>Gerade bei sensibler oder vorgeschädigter Haut kann Nagayu Spa auch <strong>begleitend zur tierärztlichen Behandlung</strong>  eingesetzt werden. Auf Wunsch erfolgt die Anwendung in enger Abstimmung mit Ihrem Tierarzt, um die Pflege optimal an den individuellen Hautzustand Ihres Hundes anzupassen.</p>

                    <ul style='text-align: left;'>
                        <p><strong>Nagayu Spa wird besonders empfohlen bei:</strong></p>
                        <li>Hautirritationen & Pilzbelastungen</li>
                        <li>Unangenehmer Haut- oder Fellgeruch</li>
                        <li>Rötungen, Hot Spots & empfindliche Haut</li>
                        <li>gestresster oder aus dem Gleichgewicht geratener Haut</li>
                        <li>Hunden, die zu Hautreaktionen oder Reizungen neigen</li>
                        <li>Geeignet für <strong> alle Rassen und Felltypen</strong>  - auch für sensible Hunde. </li>
                    </ul>

                    <ul style='text-align: left;'>
                        <p style='text-align: left;'><strong>Nagayu Spa unterstützt: </strong></p>
                        <li>Förderung der Zellregeneration</li>
                        <li>Steigerung der Durchblutung</li>
                        <li>Tiefenreinigung der Poren</li>
                        <li>Regulierung des pH-Wertes der Haut</li>
                        <li>die natürliche Hautschutzbarriere</li>
                        <li>die Beruhigung gereizter Haut</li>
                        <li>die Feuchtigkeitsversorgung bis in tiefere Hautschichten</li>
                        <li>Verbesserung von Fellstruktur & Glanz</li>
                        <li>Entspannung und Wohlbefinden</li>
                    </ul>
                    <p>Die Anwendung ist vollkommen frei von Duftstoffen, Chemie oder Rückständen und wird von den Hunden als sehr angenehm empfunden.</p>

`,
         image: image1, // Use imported image
    },
    {
id: 2,
        title: "Thalasso Schlamm",
        shortDescription: "Thalasso - die Kraft des Meeres",
        fullDescription: `
                
                <p>Die Thalasso-Behandlung nutzt hochwertige Meeresalgen, reich an Mineralien, Spurenelementen und Vitaminen. Diese natürlichen Inhaltsstoffe unterstützen die Hautregeneration und helfen, das Gleichgewicht der Haut wiederherzustellen. </p>
                <p>In Kombination mit hochwertiger Aromatherapie aus naturreinen ätherischen Ölen wirkt sie beruhigend, ausgleichend und vitalisierend. </p>
                <p>Ergänzend kann die Thalasso-Behandlung bei <strong>Milo & Mabel</strong> auf Wunsch in Kombination mit hochwertiger Aromatherapie aus naturreinen ätherischen Ölen kombiniert werden. Dies wirkt beruhigend, ausgleichend und vitalisierend. Dabei verwende ich ausschließlich <strong>natürliche, hochwertige ätherische Öle in sehr niedriger, hundegerechter Dosierung</strong>, sorgfältig ausgewählt und individuell abgestimmt. </p>
                <ul style='text-align: left;'>
                    <p><strong>Thalasso wirkt:</strong></p>
                    <li>regenerierend und stärkend auf Haut und Fell</li>
                    <li>unterstützend bei Hautirritationen und Juckreiz</li>
                    <li>durchblutungsfördernd und stoffwechselanregend</li>
                    <li>ausgleichend bei gestresster oder belasteter Haut</li>
                    <li>vitalisierend und entspannend</li>
                    <p><strong>Die Aromatherapie kann zusätzlich:</strong></p>
                    <li>zur Entspannung beitragen</li>
                    <li>Stress abbauen und das Wohlbefinden fördern</li>
                    <li>die Behandlung zu einem ganzheitlichen Spa-Erlebnis machen</li>
                </ul>
                <p>Die Aromatherapie erfolgt ausschließlich nach individueller Einschätzung und <strong>nicht bei sehr sensiblen oder allergischen Hunden. </strong></p>
                    <ul style='text-align: left;'>
                        <p><strong>Für welche Hunde sind die Spa-Behandlungen geeignet?</strong></p>
                        <p>Die Spa- und Wellnessbehandlungen bei <strong>Milo & Mabel</strong> eignen sich besonders für:</p>
                        <li>Hunde mit empfindlicher, trockener oder schuppiger Haut</li>
                        <li>Hunde mit Juckreiz oder Neigung zu Hautirritationen</li>
                        <li>Allergiker (je nach Ausprägung, nach Rücksprache) </li>
                        <li>Hunde im Fellwechsel</li>
                        <li>Senioren mit trockener oder dünner werdender Haut</li>
                        <li>Welpen ab einem geeigneten Alter</li>
                        <li>Hunde mit stumpfem, kraftlosem oder schwer kämmbarem Fell</li>
                        <li>Hunde, deren Hautgesundheit präventiv unterstützt werden soll</li>
                    </ul>
                <p><strong>Für welche Hunde sind sie nicht oder nur eingeschränkt geeignet?</strong></p>
                    <ul style='text-align: left;'><p>So wichtig mir wirksame Pflege ist, genauso wichtig ist mir Verantwortung und Ehrlichkeit. Daher werden die Behandlungen <strong>nicht</strong> oder nur nach individueller Absprache durchgeführt bei:</p>
                        <li>akuten, offenen Hautverletzungen</li>
                        <li>frischen oder nässenden Hot Spots</li>
                        <li>nicht abgeklärten Hauterkrankungen</li>
                        <li>stark entzündeten oder schmerzhaften Hautstellen</li>
                        <li>fieberhaften Erkrankungen oder starkem Unwohlsein</li>
                        <li>bekannten Unverträglichkeiten gegenüber Algen (Thalasso) </li>
                        <li>sehr sensiblen oder allergischen Hunden in Bezug auf ätherische Öle</li>
                        <p style='text-align: left;'>Im Zweifel empfehle ich immer die vorherige Abklärung durch Ihren Tierarzt.</p>
                    </ul>
                    <p>optional mit Aromatherapie aus hochwertigen ätherischen Ölen</p>
                
`,
        image: image2, // Use imported image
    },

    
];

const Services2 = () => {
    const [expandedCard, setExpandedCard] = useState(null);

    const toggleCard = (id) => {
        setExpandedCard(expandedCard === id ? null : id);
    };

    return (
        <section className="services2">
            <h2>Spa & Wellnessbehandlungen</h2>
            <h2>Natürliche Pflege für Haut, Fell & Wohlbefinden</h2>
            <p>Bei <strong>Milo & Mabel</strong> geht es um mehr als schönes Fell. Mein Anspruch ist es, die <strong>Hautgesundheit</strong> Ihres Hundes langfristig zu unterstützen und zu erhalten – denn sie ist die <strong>Basis für Wohlbefinden, Vitalität und ein gesundes Fell. </strong></p>
            <p>Aus diesem Grund biete ich ausgewählte Spa- und Wellnessbehandlungen an, die sanft, natürlich und tiefenwirksam sind: <strong>Nagayu Spa</strong> und <strong>Thalasso-Behandlungen</strong>. Beide Anwendungen ergänzen das Grooming ideal und wirken dort, wo klassische Pflege an ihre Grenzen stößt.</p>
            
            <div className="services2-grid">
                {services2Data.map((service2) => {
                    const isExpanded = expandedCard === service2.id;

                    return (
                        <div
                            key={service2.id}
                            className={`service2-card ${isExpanded ? "expanded" : ""}`}
                            aria-expanded={isExpanded}
                            onClick={() => toggleCard(service2.id)}
                        >
                            {/* Render the image */}
                            <img
                                src={service2.image}
                                alt={service2.title}
                                className="service2-image"
                            />
                            <h3>{service2.title}</h3>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: isExpanded
                                        ? service2.fullDescription
                                        : service2.shortDescription,
                                }}
                            />
                            <button
                                className="toggle-button"
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent triggering parent div click
                                    toggleCard(service2.id);
                                }}
                                aria-controls={`service2-${service2.id}`}
                            >
                                {isExpanded ? "Zeige weniger" : "Mehr Infos"}
                            </button>
                        </div>
                    );
                })}
            </div>

            <h2> Individuell, achtsam & mit ganz viel Herz</h2>
            <p>Jede Spa-Behandlung bei <strong>Milo & Mabel</strong> wird individuell auf Ihren Hund abgestimmt – auf Wunsch auch <strong>begleitend zur tierärztlichen Therapie</strong>.</p>
            <p>Ziel ist es, Haut und Fell nicht nur schön, sondern <strong>nachhaltig gesund</strong> zu pflegen. Sanft. Natürlich. Mit Liebe zum Detail. Für mehr Wohlbefinden, Balance und Lebensqualität Ihres Herzenshundes.</p>
            <br></br>
            <h2>Wichtiger Hinweis:</h2>
                <p>Bei stark verfilztem Fell oder wenn Ihr Hund nicht frisch gebadet (max. 24 Std.) ist, fällt ein zusätzlicher Aufwand an.</p>
                <p>Daher berechne ich in diesen Fällen einen pauschalen Aufschlag von 20,-€ für den erhöhten Verschleiß von Scherköpfen und Scheren.</p>
                <p>Ich bitte um Verständnis!</p>
            <br></br>
            <h2>Nach der Behandlung - Empfehlung für den Wohlfühltag Ihres Hundes</h2>
                <p>Ruhetag einplanen: Der Besuch beim Hundefriseur ist für Ihren Hund anstrengend - gönnen Sie ihm danach einen ruhigen Tag ohne Stress.</p>
                <p>Ruhezeit einhalten: Bitte lassen Sie Ihren Hund nach der Behandlung mindestens 2 Stunden ruhen. </p>
                <p>Keine körperlichen Aktivitäten: Am Behandlungstag bitte auf größere Belastungen verzichten, z.B.: Hundeschule, Physiotherapie, anderungen / Bergtouren, Sportliche Aktivitäten</p>
            <br></br>
            <h2>Betreuungskosten</h2>
                <p>Es ist mir sehr wichtig, mich während der Behandlung voll und ganz auf Ihren Hund konzentrieren zu können.</p>
                <p>Daher betreue ich in meinem Salon immer nur einen Hund.</p>
                <p>Um diesen individuellen Service gewährleisten zu können, bitte ich Sie, die vereinbarten Zeiten pünktlich einzuhalten.</p>
                <p>Bei einer verspäteten Abholung (ab 15 Minuten über dem vereinbarten Zeitpunkt) muss ich leider eine Betreuungsgebühr von 15€ pro angefangene</p>
                <p>Viertelstunde berechnet. Vielen Dank für Ihr Verständnis!</p>

            </section>
    );
};

export default Services2;